<template>
  <div>
    <a-card title="短信消息记录">
       <a-tabs type="card"  default-active-key="errorcode" @change="callback" style="top:10px;bottom:30px">
         
            <a-tab-pane key="1" tab="中仑平台"> 
           </a-tab-pane>

            <a-tab-pane key="2" tab="动态签名" force-render>
            </a-tab-pane>

            <a-tab-pane key="3" tab="商户">
            </a-tab-pane>
        </a-tabs>     

     <!-- 搜索框 -->
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="手机号">
              <a-input  v-model="searchP.telephone"  placeholder="手机号号" ></a-input>
          </a-form-item>
          <a-form-item label="商户号">
              <a-input  v-model="searchP.shopcode"  placeholder="商户选项必填" ></a-input>
          </a-form-item>
          <a-form-item label="短信模板名称">
              <a-input  v-model="searchP.templatename"  placeholder="短信模板名称" ></a-input>
          </a-form-item>
         <a-form-item label="发送状态">
                <a-select v-model="searchP.status"  placeholder="" style="width:120px;">
                    <a-select-option value="">
                    全部
                    </a-select-option>
                    <a-select-option value="1">
                    成功
                    </a-select-option>
                    <a-select-option value="0">
                    失败
                    </a-select-option>
                    <a-select-option value="2">
                    发送中
                    </a-select-option>
                </a-select>
        </a-form-item>
        <a-form-item label="模版类型">
              <a-select v-model="searchP.templatetype"  placeholder="" style="width:120px;">
                    <a-select-option value="">
                    全部
                    </a-select-option>
                    <a-select-option value="1">
                    验证码
                    </a-select-option>
                    <a-select-option value="2">
                    通知短信
                    </a-select-option>
                    <a-select-option value="3">
                    推广短信
                    </a-select-option>
                </a-select>
          </a-form-item>
          <a-form-item label="签名">
             <a-select  v-model="searchP.signname"  style="width:120px;">
                   <a-select-option v-for="(item,index) in signnamelist" :key="index" v-model="item.signname">
                     {{item.signname}}
                   </a-select-option>
             </a-select>
          </a-form-item>
          
        <a-form-item label="错误码">
                <a-input  v-model="searchP.errmsgcn"  placeholder="错误码" ></a-input>
        </a-form-item>
        <a-form-model-item  label="开始日期" prop="starttime">
            <a-date-picker v-model="searchP.starttime" format="YYYY-MM-DD" />
         </a-form-model-item>
         <a-form-model-item  label="结束日期" prop="endtime">
            <a-date-picker  v-model="searchP.endtime"   format="YYYY-MM-DD" />
         </a-form-model-item>
         
          
          <a-form-item>
            <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 短信列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :scroll="{ x: 800}" :loading="tLoading" rowKey="id" >
       <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'smsDetailUrl',
                    query: {
                        id: record.id,
                        shopcode:searchP.shopcode,
                        sendType: sendType,
                    }
                }"
                >查看</router-link>
          </span>
        </div>
      </template>

      <template slot="status" slot-scope="text">
        <div >
          <span v-if="text=='1'" style="color:green">
            成功
          </span>
          <span v-else-if="text=='2'" style="color:gray">
             发送中   
          </span>
          <span v-else-if="text=='0'" style="color:red">
             失败   
          </span>
        </div>
      </template>
      
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "手机号",
        dataIndex: "telephone",
        width:250
    },
    
    {
        title: "短信模板名称",
        dataIndex: "templatename",
        width:350
    },
    {
        title: "短信内容",
        dataIndex: "message",
        width:700
    },
    {
        title: "模版类型",
        dataIndex: "templatetype",
        width:200
    },
    {
        title: "发送状态",
        dataIndex: "status",
        width:200,
        // customRender: text => (text == "1" ? "成功" : "失败")
        scopedSlots: { customRender: 'status' },
    },
    {
        title: "发送状态描述",
        dataIndex: "errmsgcn",
        width:300
    },

    {
        title: "发送时间",
        dataIndex: "createtime",
        width:350
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            signnamelist:[],
            datasource:{
                isShow:false,
                authedStr:''
            },
            sendType:'1' //短信平台
            
        };
    },
    methods: {

        callback(key) {
            console.log(key);
            this.sendType=key;
            if(key==3 && this.searchP.shopcode=='' ){
                this.data=[];
                return;
            }
            this.getSmsRecordList(1);        
        },

        handlePageChange(c_p){
            this.getSmsRecordList(c_p)
        },

        // 查询短信列表
        getSmsRecordList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.endtime = c_params.endtime ?  this.dateFormat('YYYY-mm-dd',new Date(c_params.endtime)) : '';
            c_params.starttime =c_params.starttime ? this.dateFormat('YYYY-mm-dd',new Date(c_params.starttime)): '';
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            c_params.sendType = this.sendType;
            this.tLoading = true;
            this.$store.dispatch({
                type: "smsmanager/list",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handleSearchReset(){

            

            this.$store.dispatch({
                type: "smsmanager/getEmptySearch",
                showMsg: true
            })
            this.querySmsSignnameList();
            this.getSmsRecordList(1);
        },

        querySmsSignnameList(){
            this.$store.dispatch({
                type: "smsmanager/querySmsSignnameList",
            }).then((res)=>{
                this.signnamelist = res.data.data;
            });
        },

        handleSubmit(e){
            e.preventDefault();
            if(this.sendType ==3 && this.searchP.shopcode=='' ){
                this.message.error("商户数据分库，请输入商户号查询！")
                return;
            }
            this.getSmsRecordList(1)

        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('smsmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        //页面加载完成-接口获取系统列表
        this.querySmsSignnameList();

        this.getSmsRecordList(1);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
